import React from "react";

const printStyles = `
  @media print {
    body * {
      visibility: hidden;
    }
    #printable-receipt {
      visibility: visible;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      max-width: 400px;
      padding: 20px;
    }
    #printable-receipt * {
      visibility: visible;
    }
    .no-print {
      display: none !important;
    }
  }
`;
const Receipt = ( {showReceipt, transactionDetails, setShowReceipt }) => {
    const handleClose = () => {
      setShowReceipt(!showReceipt);
    };
    const handleShareWhatsApp = () => {
        const message = `Transaction Details:\nType: ${transactionDetails.type}\nAmount: ₦${transactionDetails.amount}\nReference: ${transactionDetails.reference}
        Date: ${transactionDetails.date}`;
            // Check if mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
        // Use WhatsApp mobile API
        window.location.href = `whatsapp://send?text=${encodeURIComponent(message)}`;
    } else {
        // Use WhatsApp web
        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`);
    }
    };
    const handlePrint = () => {
      window.print();
    };

    const handleShareEmail = () => {
        const subject = "Transaction Receipt";
        const body = `Transaction Details:\nType: ${transactionDetails.type}\nAmount: ₦${transactionDetails.amount}\nReference: ${transactionDetails.reference}
        Date: ${transactionDetails.date}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };
    if(!showReceipt) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4 overflow-y-auto no-print">
        <style>{printStyles}</style>
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-4 my-4 relative no-print">
          <button 
                onClick={handleClose}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            >
                <span className="material-icons text-xl">close</span>
            </button>
            <div id="printable-section">
            <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <span className="material-icons text-green-500 text-2xl">check_circle</span>
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-1">Transaction Successful!</h2>
                  <p className="text-gray-600 mb-4 text-sm">Your purchase has been completed</p>
              </div>
  
              <div className="space-y-2 border-t border-b py-3 my-3 text-sm">
                  <div className="flex justify-between">
                      <span className="text-gray-600">Type</span>
                      <span className="font-medium">{transactionDetails?.type}</span>
                  </div>
                  <div className="flex justify-between">
                      <span className="text-gray-600">Network/Provider</span>
                      <span className="font-medium">{transactionDetails?.network}</span>
                  </div>
                  {transactionDetails?.plan && (
                      <div className="flex justify-between">
                          <span className="text-gray-600">Plan</span>
                          <span className="font-medium">{transactionDetails.plan}</span>
                      </div>
                  )}
                  <div className="flex justify-between">
                      <span className="text-gray-600">Phone Number</span>
                      <span className="font-medium">{transactionDetails?.phoneNumber}</span>
                  </div>
                  <div className="flex justify-between">
                      <span className="text-gray-600">Amount</span>
                      <span className="font-medium">₦{transactionDetails?.amount?.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between">
                      <span className="text-gray-600">Date</span>
                      <span className="font-medium">{transactionDetails?.date}</span>
                  </div>
                  <div className="flex justify-between">
                      <span className="text-gray-600">Reference</span>
                      <span className="font-medium">{transactionDetails?.reference}</span>
                  </div>
              </div>
            </div>
  
              <div className="flex flex-col no-print">
    <div className="text-center text-gray-500 text-xs mb-3  pt-3">Share Receipt via</div>
    <div className="grid grid-cols-3 gap-2">
        <button
            onClick={handleShareWhatsApp}
            className="py-2.5 px-2 rounded-lg border border-gray-200 text-gray-600 hover:bg-green-500 hover:text-white hover:border-green-500 transition-all duration-300 text-xs font-medium flex items-center justify-center gap-2 group"
        >
            <i className="fab fa-whatsapp text-lg group-hover:scale-110 transition-transform duration-300"></i>
            WhatsApp
        </button>
        <button
            onClick={handleShareEmail}
            className="py-2.5 px-2 rounded-lg border border-gray-200 text-gray-600 hover:bg-blue-500 hover:text-white hover:border-blue-500 transition-all duration-300 text-xs font-medium flex items-center justify-center gap-2 group"
        >
            <span className="material-icons text-lg group-hover:scale-110 transition-transform duration-300">mail</span>
            Email
        </button>
        <button
            onClick={handlePrint}
            className="py-2.5 px-2 rounded-lg border border-gray-200 text-gray-600 hover:bg-emerald-500 hover:text-white hover:border-emerald-500 transition-all duration-300 text-xs font-medium flex items-center justify-center gap-2 group"
        >
            <span className="material-icons text-lg group-hover:scale-110 transition-transform duration-300">file_download</span>
            Save
        </button>
    </div>
</div>
          </div>
      </div>
  );
}

export default Receipt;